import React, {FC, useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import {
  WrapperRow,
  Title,
  HideWrapper,
  BlueText,
  LeftSide,
  BodyText,
  BodyLink,
  QuotasContainer
} from '../../pages/cloud/Instances/styles'
import {
  Container,
  TutorItem,
  TutorTitle,
  TutorTitleWrapper,
  TutorContent,
  TutorIcon,
  TutorIconBack
} from './styles'
import { Diagrams } from "../../pages/HomePage/components";
import { useTranslation } from "react-i18next";
import { icons } from "../../icons";
import StyledIcon from "../../components/styled-icon";
import { Button, Table, TopProgress, TableSkeleton, SearchComponent } from "../../components";
import { useTheme } from "styled-components";
import Skeleton from "react-loading-skeleton";
import { useQueryParam, StringParam } from "use-query-params";
import useDebounce from "../../hooks/useDebounce";

export type TableData = {
  columns:any[],
  data:any[],
  props?:any[],
  allChecked?:any,
  setAllChecked?:any,
  checked?:any,
  setChecked?:any,
  paginationData?:any,
  updateData?:any,
  loading?:boolean,
  hideCheckbox?:boolean,
  showSearchSkeleton?:boolean,
  filterOptions?:any,
}

type StartPageProps = {
  title:string,
  noResourceText?:string,
  createResourceButton?:string,
  createResourceButtonEventOrLink?:() => void | string,
  createResourceLink?:string,
  rightButtonComponentCustom?:any,
  rightButtonComponentCustomWithResources?:any,
  learnMoreAboutResource?:string,
  learnMoreAboutResourceLink?:string,
  howCreateVideoText?:string,
  howCreateVideoUrl?:string,
  videoImage?:any,
  videoImageDark?:any,
  tableData:TableData,
  haveResource:boolean,
  setHaveResource?:(type:boolean) => void,
  hideQuotas?:boolean,
  pageLoading?:boolean,
  updateData?:any,
  withoutCreateResourceButton?:boolean,
  rightCustomCreateButton?:any,
  tutorialLeftData?:any[],
  tutorialRightData?:any[],
  searchFunc?: (search:string) => void,
}

const StartPage:FC<StartPageProps> = (props) => {
  const {
    title,
    noResourceText,
    createResourceButton=null,
    createResourceButtonEventOrLink,
    createResourceLink,
    rightButtonComponentCustom,
    rightButtonComponentCustomWithResources,
    learnMoreAboutResource,
    learnMoreAboutResourceLink,
    tableData,
    haveResource,
    pageLoading,
    withoutCreateResourceButton,
    rightCustomCreateButton,
    // searchFunc,
  } = props
  const [t] = useTranslation()
  const theme:any = useTheme()
  const navigate = useNavigate()
  // const [searchString, setSearchString] = useState<any>('')

  return (
    <Container>
      <WrapperRow>
        <Title>
          {title}
        </Title>
      </WrapperRow>
      <WrapperRow>
        {rightCustomCreateButton ? rightCustomCreateButton :
        withoutCreateResourceButton || !createResourceButton && haveResource ? null :
          <div style={{display:"flex", width:'100%',gap:"12px", alignItems:'center'}}>
            <Button
              title={createResourceButton}
              onClick={createResourceLink ? () => navigate(createResourceLink) : createResourceButtonEventOrLink}
              variant='primary'
              size='custom'
              customStyles={{height:'40px', margin:'20px 6px 20px 0px', whiteSpace:'nowrap'}}
            />
            <SearchComponent
            />
            {rightButtonComponentCustomWithResources}

          </div>
        }
      </WrapperRow>
      {pageLoading ?
        <WrapperRow style={{flexDirection:'column', marginTop:'18px'}}>

          <TopProgress loading={pageLoading}/>
          {/* <div style={{display:'flex', gap:'6px', marginBottom:'20px'}}>
            <Skeleton
              baseColor={theme.palette[300]}
              highlightColor={theme.palette[20]}
              width={144} height={40}
            />
            <Skeleton
              baseColor={theme.palette[300]}
              highlightColor={theme.palette[20]}
              width={40} height={40}
            />

          </div> */}
          <TableSkeleton
            rows={5}
            columns={tableData?.columns?.length || 5}
            columnsData={tableData.columns}
          />
        </WrapperRow>
      : haveResource ?
        <WrapperRow style={{flexDirection:'column'}}>

          <Table
            columns={tableData.columns}
            rows={tableData.data}
            settings={tableData.props}
            allChecked={tableData?.allChecked}
            setAllChecked={tableData?.setAllChecked}
            checked={tableData?.checked}
            setChecked={tableData?.setChecked}
            paginationData={tableData?.paginationData}
            updateData={tableData?.updateData}
            loading={tableData?.loading}
            hideCheckbox={tableData?.hideCheckbox}
            showSearchSkeleton={tableData?.showSearchSkeleton}
          />
        </WrapperRow>
      :
        <>
          <WrapperRow style={{marginTop:'20px', gap:'20px'}}>
            <LeftSide style={{width:'100%'}}>
              {/* @ts-ignore */}
              <BodyText>
                {noResourceText}
              </BodyText>
              {/* {withoutCreateResourceButton ? rightCustomCreateButton ? rightCustomCreateButton : null : 
                <div style={{display:"flex", width:'100%', alignItems:'center',gap:"12px"}}>
                  <Button
                    title={createResourceButton}
                    onClick={createResourceButtonEventOrLink}
                    variant='primary'
                    size='display'
                    customStyles={{ margin:'20px 0px'}}
                  />
                    <SearchComponent 
                    // search={searchString} setSearch={setSearchString}
                    />
                  {rightButtonComponentCustom ? rightButtonComponentCustom :
                  null}
                </div>
              } */}
              {/* {learnMoreAboutResource && 
                <HideWrapper onClick={() => window.open(learnMoreAboutResourceLink)}>
                  <StyledIcon src={icons.LinkBlue}/>
                  <BodyLink>{learnMoreAboutResource}</BodyLink>
                </HideWrapper>
              } */}
            </LeftSide>
          </WrapperRow>
        </>
      }
    </Container>
  )
}


export default StartPage
